import React, { FC, memo } from "react";
import { ActionsGroup, DialogTitle, IconButton } from "@evergis/ui";

import { TitleProps } from "../types";

export const Title: FC<TitleProps> = memo(({ cancelExport, children }) => (
  <DialogTitle>
    <ActionsGroup>{children}</ActionsGroup>
    <ActionsGroup>
      <IconButton kind="close" onClick={cancelExport} />
    </ActionsGroup>
  </DialogTitle>
));
